import {  Grid, useMediaQuery, useTheme } from "@material-ui/core";
import { Block, Save } from "@material-ui/icons";
import CommonButton from "app/common/Component/Button/CommonButton";
import PopupForm from "app/common/Component/Popup/PopupForm";
import { useFormikContext } from "formik";
import { observer } from "mobx-react";
import React, { memo, useRef } from "react";
import GlobitsSelectInput from "app/common/form/GlobitsSelectInput";
import { FORM_PRINT } from "app/common/LocalConst";
import { useReactToPrint } from "react-to-print";
import FormPrintTreatmentPlanTab from "./FormPrintTreatmentPlanTab";
import FormPrintServiecTab from "./FormPrintServiecTab";
import FormPrintAllTab from "./FormPrintAllTab";

const PrintPopupTreamentPlanTab = ({ open, handleClose, dataRegisterService, pageRegisterTreatmentPlan, patient }) => {
  console.log("🚀 ~ PrintPopupTreamentPlanTab ~ pageRegisterTreatmentPlan:", pageRegisterTreatmentPlan)
  
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
      content: () => componentRef.current,
      documentTitle: "In phiếu",
  });
  return (
    <PopupForm
      open={open}
      size="xxl"
      height="75vh"
      handleClose={handleClose}
      title={"In phiếu liệu trình"}
      formik={{
        initialValues: {},
        onSubmit: async (values) => {
          console.log("Data", values);
        },
        enableReinitialize: true,
      }}
      action={(values) => {
        return (
          <div className="flex-center gap-1">
            <CommonButton type="submit" onClick={handlePrint}>
              {!isMobile && <Save className="mr-2 " />}
              In phiếu
            </CommonButton>

            <CommonButton className="btn-gray" onClick={handleClose} >
              <Block className="mr-2" /> Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      {({ setFieldValue, values }) => {
        return (
          <>
            <ValueForm componentRef={componentRef} dataRegisterService={dataRegisterService} pageRegisterTreatmentPlan={pageRegisterTreatmentPlan}  patient={patient}/>
          </>
        );
      }}
    </PopupForm>
  );
};

const ValueForm = observer(({componentRef, dataRegisterService, patient, pageRegisterTreatmentPlan}) => {
  const { values, setFieldValue } = useFormikContext();
  return (
    <>
      <Grid container spacing={1}>
        <Grid
          item
          xs={12}
          className="flex-center"
          style={{ border: "1px dashed black", margin: "10px" }}
        >
          {Array.isArray(dataRegisterService) && dataRegisterService.length > 0 ? (
            <FormPrintServiecTab
              componentRef={componentRef}
              dataRegisterService={dataRegisterService}
              patient={patient}
            />
          ) : pageRegisterTreatmentPlan ? (
            <FormPrintTreatmentPlanTab
              componentRef={componentRef}
              pageRegisterTreatmentPlan={pageRegisterTreatmentPlan}
              patient={patient}
            />
          ) : (
            <p>Không có dữ liệu để hiển thị</p>
          )}
          {/* <FormPrintAllTab/> */}

        </Grid>

      </Grid>
    </>
  );
});

export default memo(observer(PrintPopupTreamentPlanTab));
